import React, { Fragment, useContext } from 'react';
import { Menu, Header, Input } from 'semantic-ui-react';
import { RootStoreContext } from '../../../../App/stores/RootStore';
import { observer } from 'mobx-react-lite';

const RequestReviewFilters = () => {
  const rootStore = useContext(RootStoreContext);
  const { predicate, setPredicate } = rootStore.requestReviewStore;

  return (
    <Fragment>
      <Menu vertical size={'large'} style={{ width: '100%' }}>
        <Header icon={'filter'} attached color={'teal'} content={'Filters'} />
        <Menu.Item
          active={predicate.size === 0}
          onClick={() => setPredicate('all', 'true')}
          color={'blue'} name={'All Requests'} content={"All Requests"} />
        <Menu.Item>
          <Input label="Case ID" placeholder='Search...'
            onChange={(regId) => setPredicate('RequestCaseId', regId.target.value.toString())}
            value={predicate.get('requestCaseId' || "")} />
        </Menu.Item>
        <Menu.Item>
          <Input label="Service Id" placeholder='Search...'
            onChange={(tdn) => setPredicate('tdn', tdn.target.value.toString())}
            value={predicate.get('tdn' || "")} />
        </Menu.Item>
        <Menu.Item>
          <Input label="Provider" placeholder='Search...'
            onChange={(provider) => setPredicate('provider', provider.target.value.toString())}
            value={predicate.get('provider' || "")} />
        </Menu.Item>
      </Menu>
    </Fragment>
  )
}

export default observer(RequestReviewFilters);